import React from "react";

interface DownloadDropdownProps {
  anchorRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  onDownloadImage: () => void;
  onDownloadPDF: () => void;
}

export const DownloadDropdown: React.FC<DownloadDropdownProps> = ({
  anchorRef,
  onClose,
  onDownloadImage,
  onDownloadPDF,
}) => {
  if (!anchorRef.current) return null;

  const rect = anchorRef.current.getBoundingClientRect();

  return (
    <>
      {/* オーバーレイ（クリックで閉じる） */}
      <div
        className="fixed inset-0"
        style={{ zIndex: 9998 }}
        onClick={onClose}
      />
      {/* ドロップダウンメニュー */}
      <div
        className="fixed bg-white border border-gray-300 rounded shadow-lg"
        style={{
          zIndex: 9999,
          top: rect.bottom + 4,
          left: rect.left,
          width: rect.width,
        }}
      >
        <button
          onClick={onDownloadImage}
          className="w-full px-3 py-2 text-left text-gray-700 hover:bg-gray-100 flex items-center gap-2 text-sm cursor-pointer"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          画像で保存
        </button>
        <button
          onClick={onDownloadPDF}
          className="w-full px-3 py-2 text-left text-gray-700 hover:bg-gray-100 flex items-center gap-2 border-t border-gray-200 text-sm cursor-pointer"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
          PDFで保存
        </button>
      </div>
    </>
  );
};

export default DownloadDropdown;
